import { ShieldCheck, Award, Leaf } from "lucide-react";
import { useLanguage } from "@/i18n";
import { Reveal } from "@/components/Reveal";

const ICONS = [ShieldCheck, Award, Leaf];

export const Certifications = () => {
    const { t } = useLanguage();
    const items = t("certs.items");

    return (
        <section data-testid="certifications-section" className="border-y border-white/10 bg-[#151921]">
            <div className="mx-auto max-w-[1600px] px-5 py-20 md:px-12 md:py-24 lg:px-24">
                <Reveal>
                    <div className="flex flex-col justify-between gap-4 md:flex-row md:items-end">
                        <h2 className="font-display text-3xl font-light italic tracking-tighter sm:text-4xl" data-testid="certs-heading">
                            {t("certs.heading")}
                        </h2>
                        <p className="max-w-md font-mono text-[10px] uppercase leading-relaxed tracking-[0.2em] text-midora-red" data-testid="certs-sub">
                            {t("certs.sub")}
                        </p>
                    </div>
                </Reveal>
                <div className="mt-12 grid gap-px border border-white/10 bg-white/10 md:grid-cols-3">
                    {items.map((item, i) => {
                        const Icon = ICONS[i];
                        return (
                            <Reveal key={item.label} delay={i * 0.08} className="bg-[#151921] p-8 md:p-10">
                                <div data-testid={`cert-${item.label.toLowerCase().replace(" ", "-")}`}>
                                    <Icon className="h-6 w-6 text-white/70" />
                                    <h3 className="mt-6 font-mono text-sm uppercase tracking-[0.3em] text-midora-red">{item.label}</h3>
                                    <p className="mt-3 text-sm leading-relaxed text-[#DBD1BD]/60">{item.text}</p>
                                </div>
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
